import {
  MonthPickerProps as MantineMonthPickerProps,
  MonthPicker as MantineMonthPicker,
} from '@mantine/dates';

export type MonthPickerProps<
  Type extends 'default' | 'range' | 'multiple' = 'default'
> = MantineMonthPickerProps<Type>;

export const MonthPicker = <
  Type extends 'default' | 'range' | 'multiple' = 'default'
>(
  props: MonthPickerProps<Type> & { ref?: React.ForwardedRef<HTMLDivElement> }
) => {
  return <MantineMonthPicker {...props} />;
};

MonthPicker.displayName = 'MonthPicker';
